<template>
  <el-dialog
    :visible="dialogVisible"
    width="500px"
    :before-close="close"
    :close-on-click-modal="false"
    :title="title"
    class="customDialogForm"
  >
    <el-form ref="versionform" :rules="rules" :model="message">
      <el-form-item prop="note" label="备注" :label-width="formLabelWidth">
        <el-input
          type="textarea"
          v-model="message.note"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button
type="primary"
@click="submit"
:loading="Loading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { handleEnterpriseMessage } from '@/api/message';
import { errorHandle } from '@/utils/error';
export default {
  name: 'EditAppVersion',
  props: {
    eid: String,
    messageID: String,
    dialogVisible: Boolean,
    onClose: Function,
    onSuccess: Function
  },
  data() {
    return {
      message: {
        status: 'finished',
        note: '',
        messageID: this.messageID
      },
      rules: {
        note: [
          { required: true, message: '请填写备注', trigger: 'blur' },
          {
            min: 2,
            max: 255,
            message: '备注最少两个字符，最多不能超过255字符',
            trigger: 'blur'
          }
        ]
      },
      app: {},
      title: '处理异常信息',
      formLabelWidth: '80px',
      Loading: false
    };
  },
  created() {},
  methods: {
    submit() {
      this.Loading = true;
      this.$refs.versionform.validate((valid) => {
        if (valid) {
          this.message.eid = this.eid;
          this.message.messageID = this.messageID;
          handleEnterpriseMessage(this.message)
            .then((res) => {
              this.Loading = false;
              this.onSuccess && this.onSuccess();
              this.$refs.versionform.resetFields();
            })
            .catch((err) => {
              this.Loading = false;
              errorHandle(err);
            });
        } else {
          this.Loading = false;
        }
      });
    },
    close() {
      this.$refs.versionform.resetFields();
      this.onClose && this.onClose();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/warningInfo/components/handleMessage.vue